const Beverage = () => {
	return (
		<div class="menu">
			<img
				src="https://ik.imagekit.io/manav11goyal11/family-chaat/menu/Beverage-1.jpg"
				alt="Beverage"
			/>
		</div>
	);
};

export default Beverage;
